import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Template, TemplateTask } from '../template';
import { TemplateService } from '../template.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TemplateComponent } from '../template/template.component';
import { MessageService, ConfirmationService } from 'primeng/api';
import { AlertService } from '@app/_services';

@Component({
    selector: 'app-template-list',
    templateUrl: './template-list.component.html',
    styleUrls: ['./template-list.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class TemplateListComponent implements OnInit {
  templates: Template[] = [];
  loading = false;
  @Output() templateSelected = new EventEmitter<Template>();

  columns: any[] = [
    { field: 'templateId', header: 'ID', width: '10%' },
    { field: 'name', header: 'Name', width: '30%' },
    { field: 'description', header: 'Description', width: '30%' },
    { field: 'tasks', header: 'Tasks', width: '15%' },
    { field: 'isActive', header: 'Status', width: '10%' },
    { field: 'actions', header: 'Actions', width: '5%' }
  ];

  constructor(
    private templateService: TemplateService,
    private dialog: MatDialog,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private alertService: AlertService
  ) {}

  ngOnInit(): void {
    this.loadTemplates();
  }

  loadTemplates(): void {
    this.loading = true;
    this.templateService.getAll().subscribe({
      next: (templates) => {
        this.templates = templates;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading templates:', err);
        this.loading = false;
      }
    });
  }

  addTemplate(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.maxWidth = "90vw";
    dialogConfig.width = "80vw";
    dialogConfig.data = {
      title: 'Add Template',
      template: null
    };

    const dialogRef = this.dialog.open(TemplateComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadTemplates();
      }
    });
  }

  editTemplate(template: Template): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.maxWidth = "90vw";
    dialogConfig.width = "80vw";
    dialogConfig.data = {
      title: 'Edit Template',
      template: template
    };

    const dialogRef = this.dialog.open(TemplateComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadTemplates();
      }
    });
  }

  deleteTemplate(template: Template): void {
    this.confirmationService.confirm({
      message: `Are you sure you want to delete template "${template.name}"?`,
      header: 'Confirm Delete',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.templateService.delete(template.templateId).subscribe({
          next: (res) => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Template deleted successfully' });
            this.loadTemplates();
          },
          error: (err) => {
            this.alertService.error(err);
          }
        });
      }
    });
  }

  toggleActive(template: Template): void {
    template.isActive = !template.isActive;
    this.templateService.update(template).subscribe({
      next: (res) => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: `Template ${template.isActive ? 'activated' : 'deactivated'} successfully` });
        this.loadTemplates();
      },
      error: (err) => {
        template.isActive = !template.isActive; // Revert on error
        this.alertService.error(err);
      }
    });
  }

  getTaskCount(template: Template): number {
    return template.tasks ? template.tasks.length : 0;
  }
}

